import React from 'react';
import Container from 'react-bootstrap/Container';

const NotFoundPage: React.FC = () => {
    return (
        <Container>
            <h1>Page Not Found</h1>
        </Container>
    );
};

export default NotFoundPage;